import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import Modal from '../../shared/components/Modal';
import CarGallery from './CarGallery';
import { listCarImages } from '../utils/carImages';

/**
 * CarDetailsModal — read-only car detail view with the professional image
 * gallery + fullscreen lightbox (via CarGallery). Additive; opened from CarsPage.
 */
export default function CarDetailsModal({ car, settings = {}, onClose }) {
  const { lang, t } = useLanguage();
  const isAr = lang === 'ar';
  const [images, setImages] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      const imgs = await listCarImages(car.id);
      if (alive) setImages(imgs);
    })();
    return () => { alive = false; };
  }, [car.id]);

  const info = [
    [isAr ? 'السنة' : 'Année', car.year],
    [isAr ? 'اللوحة' : 'Plaque', car.plate],
    [isAr ? 'الوقود' : 'Carburant', car.fuel],
    [`${isAr ? 'السعر' : 'Prix'}/${isAr ? 'يوم' : 'jour'}`, car.dailyRate ? `${car.dailyRate} ${settings.currency || ''}` : null],
    [isAr ? 'المدينة' : 'Ville', car.city],
  ].filter(([, v]) => v);

  return (
    <Modal onClose={onClose} title={`${car.brand || ''} ${car.model || ''}`.trim() || (isAr ? 'تفاصيل السيارة' : 'Détails du véhicule')}>
      <div>
        <CarGallery
          images={images || []}
          fallback={car.photo}
          alt={`${car.brand} ${car.model}`}
          isAr={isAr}
        />

        {info.length > 0 && (
          <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3">
            {info.map(([label, value]) => (
              <div key={label} className="rounded-xl border border-gray-100 bg-gray-50 p-3">
                <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">{label}</div>
                <div className="mt-0.5 text-sm font-bold text-gray-900">{value}</div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-5 border-t border-gray-100 pt-4">
          <button
            onClick={onClose}
            className="w-full rounded-xl border border-gray-300 px-4 py-3 text-sm font-bold text-gray-700 transition hover:bg-gray-50"
          >
            {t('close_btn') || (isAr ? 'إغلاق' : 'Fermer')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
